import { useMemo } from 'react';

import useConfiguration from './useConfiguration';

export interface DirectionProperties {
  start: 'left' | 'right';
  end: 'left' | 'right';
  rtl: boolean;
  ltr: boolean;
}

const useDirection = (): Readonly<DirectionProperties> => {
  const { direction } = useConfiguration();
  return useMemo<DirectionProperties>(() => {
    return direction === 'ltr'
      ? {
          start: 'left',
          end: 'right',
          ltr: true,
          rtl: false
        }
      : {
          start: 'right',
          end: 'left',
          ltr: false,
          rtl: true
        };
  }, [direction]);
};

export default useDirection;
